import { OK } from 'http-status-codes';

import getAxiosInstance from '../../../helpers/get_axios_instance';

  export const getUltimaVersionLaridae=async(): Promise<string> => {
    const axios = getAxiosInstance()
    try {
      const ultimaVersionLaridaeResponse = await axios.get(`ultima_version_laridae`);
      const { status, data } = ultimaVersionLaridaeResponse;
      if (status === OK) {
        return data.filas[0].ultimaVersion;
      }
      throw new Error('No se pudo obtener la ultima version de laridae.')
    } catch (error) {
      throw new Error('No se pudo obtener la ultima version de laridae.')
    }
  }
